import { type FC } from 'react';

import { VerticalSlider } from 'shared/components/VerticalSlider';
import { type ArrayOfObjects } from 'shared/types/ArrayOfObjects';

import { Arrow } from './internal/components/Arrow';
import { CarouselSlide } from './internal/components/CarouselSlide';

type Slide = {
  imageSrc: string;
  title: string;
  description: string;
};

export type SpecialProjectCarouselProps = {
  media: ArrayOfObjects<Slide>;
  onSlideClick: (slideIndex: number) => void;
  onArrowClick: (direction: 'left' | 'right') => void;
};

export const Carousel: FC<SpecialProjectCarouselProps> = props => {
  const { media, onSlideClick, onArrowClick } = props;

  return (
    <VerticalSlider arrow={Arrow} onArrowClick={onArrowClick} onItemClick={onSlideClick}>
      {media.map(slide => (
        <CarouselSlide description={slide.description} imageSrc={slide.imageSrc} key={slide.id} title={slide.title} />
      ))}
    </VerticalSlider>
  );
};
